import { EnterpriseScopeCounterDiscriminator } from '@mews-commander/data-access';

export enum CounterPageTab {
    BillCounters = 'BillCounters',
    ProformaCounters = 'ProformaCounters',
    PreviewCounters = 'PreviewCounters',
    CreditNoteCounters = 'CreditNoteCounters',
    SystemGeneratedCounters = 'SystemGeneratedCounters',
}

export const isSystemGeneratedCounter = (counterType: EnterpriseScopeCounterDiscriminator) =>
    counterType === EnterpriseScopeCounterDiscriminator.AvailabilityBlockCounter ||
    counterType === EnterpriseScopeCounterDiscriminator.FiscalCounter ||
    counterType === EnterpriseScopeCounterDiscriminator.RegistrationCardCounter ||
    counterType === EnterpriseScopeCounterDiscriminator.ServiceOrderCounter ||
    counterType === EnterpriseScopeCounterDiscriminator.CorrectionBillCounter ||
    counterType === EnterpriseScopeCounterDiscriminator.PaymentConfirmationBillCounter;
